import { from } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const attachFingerprint$ = from(FingerprintJS.load())
	.pipe(
		concatMap(agent => from(agent.get())),
		tap((fingerprint) => {
			localStorage.setItem('fingerprint', fingerprint.visitorId);
		}));
